import { render, staticRenderFns } from "./shared-papers-list.html?vue&type=template&id=df32dd5c&scoped=true&"
import script from "./shared-papers-list.js?vue&type=script&lang=js&"
export * from "./shared-papers-list.js?vue&type=script&lang=js&"
import style0 from "./shared-papers-list.scss?vue&type=style&index=0&id=df32dd5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df32dd5c",
  null
  
)

export default component.exports